<template>
  <div class="generate-history-container">
    <!-- 统计卡片 -->
    <div class="stats-row" v-if="statsLoaded">
      <div class="stat-card stat-total">
        <div class="stat-icon"><i class="el-icon-s-data"></i></div>
        <div class="stat-info">
          <div class="stat-label">总记录数</div>
          <div class="stat-value">{{ stats.total }}</div>
        </div>
      </div>
      <div class="stat-card stat-text">
        <div class="stat-icon"><i class="el-icon-document"></i></div>
        <div class="stat-info">
          <div class="stat-label">文案记录</div>
          <div class="stat-value">{{ stats.text }}</div>
        </div>
      </div>
      <div class="stat-card stat-image">
        <div class="stat-icon"><i class="el-icon-picture"></i></div>
        <div class="stat-info">
          <div class="stat-label">图片记录</div>
          <div class="stat-value">{{ stats.image }}</div>
        </div>
      </div>
      <div class="stat-card stat-video">
        <div class="stat-icon"><i class="el-icon-video-camera"></i></div>
        <div class="stat-info">
          <div class="stat-label">视频记录</div>
          <div class="stat-value">{{ stats.video }}</div>
        </div>
      </div>
      <div class="stat-card stat-drama">
        <div class="stat-icon"><i class="el-icon-film"></i></div>
        <div class="stat-info">
          <div class="stat-label">短剧记录</div>
          <div class="stat-value">{{ stats.drama }}</div>
        </div>
      </div>
    </div>

    <el-card shadow="hover">
      <!-- 筛选区域 -->
      <div class="filter-section">
        <el-select v-model="filter.module" placeholder="模块类型" clearable @change="fetchHistory" size="small" style="width: 130px; margin-right: 8px;">
          <el-option label="全部" value="" />
          <el-option label="文案" value="text" />
          <el-option label="图片" value="image" />
          <el-option label="视频" value="video" />
          <el-option label="短剧" value="drama" />
        </el-select>
        <el-date-picker v-model="filter.date_range" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="fetchHistory" size="small" style="width: 260px; margin-right: 8px;" />
        <el-button type="primary" size="small" @click="fetchHistory"><i class="el-icon-search"></i> 搜索</el-button>
        <el-button size="small" @click="resetFilter"><i class="el-icon-refresh"></i> 重置</el-button>
      </div>

      <!-- 表格 -->
      <el-table :data="historyList" style="width: 100%" v-loading="loading" stripe :header-cell-style="{background:'#f5f7fa',color:'#606266'}" :cell-style="{color:'#303133'}">
        <el-table-column prop="user_id" label="用户ID" width="60" />
        <el-table-column prop="email" label="注册邮箱" width="130" show-overflow-tooltip />
        <el-table-column label="模块" width="60">
          <template slot-scope="scope">
            <el-tag :type="getModuleType(scope.row.module)" size="small">{{ scope.row.module_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="使用模型" width="100" show-overflow-tooltip />
        <el-table-column prop="prompt" label="提示词/标题" min-width="150" max-width="200" show-overflow-tooltip />
        <el-table-column prop="created_at" label="生成时间" width="165" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <div class="action-btns">
              <el-button size="mini" type="primary" @click="viewDetail(scope.row)"><i class="el-icon-view"></i> 详情</el-button>
              <el-button size="mini" type="danger" @click="deleteRecord(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.page_size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
      </div>
    </el-card>

    <!-- 查看详情对话框 -->
    <el-dialog title="记录详情" :visible.sync="detailDialogVisible" width="800px">
      <div class="detail-content" v-if="currentRecord">
        <div class="detail-header">
          <el-tag :type="getModuleType(currentRecord.module)" size="medium">{{ currentRecord.module_name }}</el-tag>
          <span class="detail-id">ID: {{ currentRecord.id }}</span>
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">用户ID：</span>
            <span class="value">{{ currentRecord.user_id }}</span>
          </div>
          <div class="detail-item">
            <span class="label">注册邮箱：</span>
            <span class="value">{{ currentRecord.email || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">使用模型：</span>
            <span class="value">{{ currentRecord.model || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">提示词/标题：</span>
            <span class="value">{{ currentRecord.prompt || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">生成时间：</span>
            <span class="value">{{ currentRecord.created_at }}</span>
          </div>
        </div>

        <!-- 视频详情 -->
        <div class="detail-section" v-if="currentRecord.module === 'video'">
          <h4><i class="el-icon-video-camera"></i> 视频详情</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">分辨率：</span>
              <span class="value">{{ extra.resolution || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">尺寸：</span>
              <span class="value">{{ extra.size || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">时长：</span>
              <span class="value">{{ extra.duration || '-' }}</span>
            </div>
          </div>
          <div class="detail-item" v-if="extra.video_url">
            <span class="label">视频链接：</span>
            <span class="value"><a :href="extra.video_url" target="_blank" class="link">{{ extra.video_url }}</a></span>
          </div>
          <div class="preview-container" v-if="extra.thumbnail">
            <span class="label">缩略图：</span>
            <img :src="extra.thumbnail" class="preview-img" />
          </div>
          <div class="preview-container" v-if="extra.reference_image">
            <span class="label">参考图片：</span>
            <img :src="extra.reference_image" class="preview-img" />
          </div>
        </div>

        <!-- 图片详情 -->
        <div class="detail-section" v-if="currentRecord.module === 'image'">
          <h4><i class="el-icon-picture"></i> 图片详情</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">风格：</span>
              <span class="value">{{ extra.style || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">比例：</span>
              <span class="value">{{ extra.aspect_ratio || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">尺寸：</span>
              <span class="value">{{ extra.size || '-' }}</span>
            </div>
          </div>
          <div class="detail-item" v-if="extra.negative_prompt">
            <span class="label">负面提示词：</span>
            <span class="value">{{ extra.negative_prompt }}</span>
          </div>
          <div class="preview-container" v-if="extra.image_url">
            <span class="label">生成图片：</span>
            <img :src="extra.image_url" class="preview-img" />
          </div>
          <div class="preview-container" v-if="extra.reference_image">
            <span class="label">参考图片：</span>
            <img :src="extra.reference_image" class="preview-img" />
          </div>
        </div>

        <!-- 文案详情 -->
        <div class="detail-section" v-if="currentRecord.module === 'text'">
          <h4><i class="el-icon-document"></i> 文案详情</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">主题：</span>
              <span class="value">{{ extra.topic || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">关键词：</span>
              <span class="value">{{ extra.keywords || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">类型：</span>
              <span class="value">{{ extra.type || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">风格：</span>
              <span class="value">{{ extra.style || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">长度：</span>
              <span class="value">{{ extra.length || '-' }}</span>
            </div>
          </div>
          <div class="detail-textarea" v-if="extra.content">
            <span class="label">生成内容：</span>
            <div class="content-box">{{ extra.content }}</div>
          </div>
        </div>

        <!-- 短剧详情 -->
        <div class="detail-section" v-if="currentRecord.module === 'drama'">
          <h4><i class="el-icon-film"></i> 短剧详情</h4>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="label">标题：</span>
              <span class="value">{{ extra.title || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">风格：</span>
              <span class="value">{{ extra.style || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="label">时长：</span>
              <span class="value">{{ extra.duration || '-' }}</span>
            </div>
          </div>
          <div class="detail-textarea" v-if="extra.script">
            <span class="label">剧本：</span>
            <div class="content-box">{{ extra.script }}</div>
          </div>
          <div class="detail-textarea" v-if="extra.storyboard">
            <span class="label">分镜脚本：</span>
            <div class="content-box">{{ extra.storyboard }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GenerateHistory',
  data() {
    return {
      loading: false,
      historyList: [],
      targetUserId: null,
      filter: {
        module: '',
        date_range: []
      },
      pagination: {
        page: 1,
        page_size: 20,
        total: 0
      },
      detailDialogVisible: false,
      currentRecord: null,
      statsLoaded: false,
      stats: {
        total: 0,
        text: 0,
        image: 0,
        video: 0,
        drama: 0
      }
    }
  },
  computed: {
    extra() {
      return this.currentRecord ? (this.currentRecord.extra_info || {}) : {}
    }
  },
  mounted() {
    this.targetUserId = this.$route.query.user_id || null
    this.fetchHistory()
  },
  methods: {
    async fetchHistory() {
      this.loading = true
      try {
        let params = {
          page: this.pagination.page,
          page_size: this.pagination.page_size
        }
        if (this.targetUserId) params.user_id = this.targetUserId
        if (this.filter.module) params.module = this.filter.module
        if (this.filter.date_range && this.filter.date_range.length === 2) {
          params.start_date = this.filter.date_range[0]
          params.end_date = this.filter.date_range[1]
        }

        const queryString = Object.keys(params)
          .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
          .join('&')

        const response = await fetch(`/api/admin/generate-history?${queryString}`)
        const result = await response.json()

        if (result.success) {
          this.historyList = result.data.records
          this.pagination.total = result.data.total
          this.pagination.page = result.data.page

          if (!this.statsLoaded && !this.targetUserId && !this.filter.module && !this.filter.date_range.length) {
            this.loadStats()
          }
        } else {
          this.$message.error(result.message || '获取记录失败')
        }
      } catch (error) {
        console.error('获取生成记录失败:', error)
        this.$message.error('获取生成记录失败')
      } finally {
        this.loading = false
      }
    },

    async loadStats() {
      try {
        const modules = ['text', 'image', 'video', 'drama']
        const promises = modules.map(async (mod) => {
          const params = { page: 1, page_size: 1, module: mod }
          const qs = Object.keys(params).map(k => `${k}=${params[k]}`).join('&')
          const res = await fetch(`/api/admin/generate-history?${qs}`)
          const data = await res.json()
          return { module: mod, total: data.success ? data.data.total : 0 }
        })

        const results = await Promise.all(promises)
        results.forEach(r => {
          this.stats[r.module] = r.total
        })
        this.stats.total = results.reduce((sum, r) => sum + r.total, 0)
        this.statsLoaded = true
      } catch (e) {
        console.error('加载统计失败:', e)
        this.statsLoaded = true
      }
    },

    resetFilter() {
      this.filter = { module: '', date_range: [] }
      this.pagination.page = 1
      this.fetchHistory()
    },

    viewDetail(record) {
      this.currentRecord = record
      this.detailDialogVisible = true
    },

    getModuleType(module) {
      const types = { text: 'success', image: 'primary', video: 'warning', drama: 'danger' }
      return types[module] || 'info'
    },

    handleSizeChange(val) {
      this.pagination.page_size = val
      this.pagination.page = 1
      this.fetchHistory()
    },

    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchHistory()
    },

    async deleteRecord(record) {
      this.$confirm('确定要删除该条生成记录吗？此操作不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await fetch(`/api/admin/generate-history/${record.id}`, {
            method: 'DELETE'
          })
          const result = await response.json()
          if (result.success) {
            this.$message.success('删除成功')
            this.fetchHistory()
          } else {
            this.$message.error(result.message || '删除失败')
          }
        } catch (error) {
          console.error('删除记录失败:', error)
          this.$message.error('删除记录失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.generate-history-container {
  padding: 0;
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 140px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.stat-total { border-left: 3px solid #409EFF; }
.stat-text { border-left: 3px solid #67C23A; }
.stat-image { border-left: 3px solid #409EFF; }
.stat-video { border-left: 3px solid #E6A23C; }
.stat-drama { border-left: 3px solid #F56C6C; }

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: #ecf5ff;
  color: #409EFF;
}

.stat-text .stat-icon { background: #f0f9eb; color: #67C23A; }
.stat-image .stat-icon { background: #ecf5ff; color: #409EFF; }
.stat-video .stat-icon { background: #fdf6ec; color: #E6A23C; }
.stat-drama .stat-icon { background: #fef0f0; color: #F56C6C; }

.stat-info { display: flex; flex-direction: column; }
.stat-label { font-size: 12px; color: #909399; margin-bottom: 4px; }
.stat-value { font-size: 22px; font-weight: 700; color: #303133; }

/* 筛选区域 */
.filter-section {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* 分页 */
.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 详情对话框 */
.detail-content { padding: 10px 0; }
.detail-header { display: flex; align-items: center; gap: 12px; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #EBEEF5; }
.detail-id { color: #909399; font-size: 14px; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.detail-item { display: flex; align-items: flex-start; padding: 8px 0; }
.detail-item .label { width: 100px; color: #909399; flex-shrink: 0; font-size: 13px; }
.detail-item .value { flex: 1; color: #303133; font-size: 13px; }

.detail-section { margin-top: 24px; padding-top: 20px; border-top: 1px solid #EBEEF5; }
.detail-section h4 { margin: 0 0 16px 0; color: #303133; font-size: 15px; display: flex; align-items: center; gap: 8px; }
.detail-section h4 i { color: #409EFF; }

.preview-container { display: flex; align-items: flex-start; margin-top: 12px; }
.preview-container .label { width: 100px; color: #909399; flex-shrink: 0; font-size: 13px; }
.preview-img { max-width: 300px; max-height: 200px; border: 1px solid #DCDFE6; border-radius: 8px; }

.detail-textarea { margin-top: 12px; }
.detail-textarea .label { width: 100px; color: #909399; flex-shrink: 0; font-size: 13px; display: block; margin-bottom: 8px; }
.content-box { background: #f5f7fa; border: 1px solid #EBEEF5; border-radius: 8px; padding: 16px; color: #303133; font-size: 13px; line-height: 1.8; white-space: pre-wrap; max-height: 300px; overflow-y: auto; }

.link { color: #409EFF; text-decoration: none; font-size: 12px; word-break: break-all; }
.link:hover { text-decoration: underline; }

.dialog-footer { display: flex; justify-content: flex-end; }

/* 操作按钮 */
.action-btns { display: flex; gap: 6px; align-items: center; }
</style>
